import { render, staticRenderFns } from "./OrderCouponList.vue?vue&type=template&id=2f26fdd1&scoped=true&"
import script from "./OrderCouponList.vue?vue&type=script&lang=ts&"
export * from "./OrderCouponList.vue?vue&type=script&lang=ts&"
import style0 from "./OrderCouponList.vue?vue&type=style&index=0&id=2f26fdd1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f26fdd1",
  null
  
)

export default component.exports